import * as React from 'react'
import {
    Link,
    Redirect,
    Route,
    Switch,
    useHistory,
    useLocation,
    useRouteMatch,
} from 'react-router-dom'

import { ProgressIndicator } from '../../components/authentication/progress-indicator'
import { VerificationCodeForm } from '../../components/authentication/verification-code-form'
import { ProfileInfoForm } from '../../components/profile-info-form'
import { Paths } from '../../config/routes'
import { ProfileContextProvider } from '../../contexts/settings/profile'
import { useUser } from '../../contexts/user/user-context'
import { SignUpForm } from './sign-up-form'
export const I18n = {
    STEP1_TITLE: 'Create accoutn',
    STEP2_TITLE: 'Enter 2FA 6-digit code',
    STEP3_TITLE: 'Profile info',
}

export function SignUpFlow() {
    const { user, setUser } = useUser()
    const match = useRouteMatch()
    const history = useHistory()
    const location = useLocation()

    const step = getStep(location.pathname, match.path)

    return (
        <div className='h-full pt-6 overflow-auto md:pt-12 scrollbar-hide'>
            {location.pathname === Paths.SIGN_UP ? (
                // Render a custom heading for this flow if your on the first step (IE no user in state)
                <header>
                    <p className='mb-12 text-lg lg:text-right text-gray'>
                        Already have an account?{' '}
                        <Link to={Paths.SIGN_IN} className='text-black'>
                            Sign in
                        </Link>
                    </p>
                </header>
            ) : (
                <ProgressIndicator
                    step={step}
                    total={3}
                    stepText={[
                        I18n.STEP1_TITLE,
                        I18n.STEP2_TITLE,
                        I18n.STEP3_TITLE,
                    ]}
                    onBack={() => history.goBack()}
                />
            )}
            <div className='h-screen max-w-lg overflow-auto'>
                <Switch>
                    <Route path={match.path} exact={true}>
                        <SignUpForm
                            onComplete={user => {
                                setUser(user)
                                history.push(`${match.path}/confirm`)
                            }}
                        />
                    </Route>
                    <Route
                        path={`${match.path}/confirm`}
                        render={() => {
                            if (!user) {
                                // Redirect to the start of sign up flow. This should only happen if
                                // someone navigates directly to one of the nested routes
                                return <Redirect to={Paths.SIGN_UP} />
                            }
                            return (
                                <VerificationCodeForm
                                    user={user}
                                    onComplete={() => {
                                        history.push(`${match.path}/profile`)
                                    }}
                                />
                            )
                        }}
                    />
                    <Route
                        path={`${match.path}/profile`}
                        render={() => {
                            if (!user) {
                                // Redirect to the start of sign up flow. This should only happen if
                                // someone navigates directly to one of the nested routes
                                return <Redirect to={Paths.SIGN_UP} />
                            }
                            return (
                                <ProfileContextProvider>
                                    <ProfileInfoForm
                                        onComplete={() => {
                                            history.push(Paths.ONBOARDING)
                                        }}
                                    />
                                </ProfileContextProvider>
                            )
                        }}
                    />
                </Switch>
            </div>
        </div>
    )
}

function getStep(pathname: string, matchPath: string) {
    if (pathname === `${matchPath}/confirm`) {
        return 2
    } else if (pathname === `${matchPath}/profile`) {
        return 3
    }

    return 1
}
